export const getPages = (totalPages: number, perSection: number = 2) => {
  const pages = [];
  if (totalPages <= perSection * 3 + 2) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  }
  for (let i = 1; i <= perSection; i++) {
    pages.push(i);
  }
  const lim1 = Math.ceil(totalPages / 2 - perSection / 2);

  if (pages.at(-1)! < lim1 - 1) {
    pages.push(0);
  }

  for (let i = 0; i < perSection; i++) {
    pages.push(lim1 + i);
  }
  pages.push(0);
  for (let i = 1; i <= perSection; i++) {
    pages.push(totalPages - perSection + i);
  }

  return pages;
};

export const copyToClipboard = (text: string) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text);
    return;
  }

  const tempTextArea = document.createElement("textarea");
  tempTextArea.value = text;
  document.body.appendChild(tempTextArea);
  tempTextArea.select();
  document.execCommand("copy");
  document.body.removeChild(tempTextArea);
};
